import React from 'react';
import fitness from '../../../images/fitness.PNG';
import crispy from '../../../images/crispy.PNG';
import soccer from "../../../images/soccer.PNG";
import MyWorkDetail from '../MyWorkDetail/MyWorkDetail';
import Fade from 'react-reveal/Fade';

const workDetails =[
    {
        projectName : "Fitness Guru Full Stack Web App",
        description : "This site is basically about a training center which provide services like indoor cycling, yoga , special gym and so on. ",
        technology : "React.js, React-Router, Private Route, Firebase Authentication, Axios, Bootstrap, ImgBB, MongoDB, Node.js, Express.js, and Heroku, Firebase for deployment",
        workPhoto : fitness,
        link:"https://fitness-guru-37c01.web.app",
        source:"https://github.com/moon-saha-chowdhury/fitness-guru",
    },
    {
        projectName : "Crispy Snacks Full Stack Web App",
        description : "Basically it's a food ordering app. Includes login system with google sign-in and responsive for (desktop and mobile view)",
        technology : "React.js, React-Router, Private Route, Firebase Authentication, Axios, Bootstrap, ImgBB, MongoDB, Node.js, Express.js, and Heroku, Firebase for deployment",
        workPhoto : crispy,
        link:"https://crispy-snacks.web.app",
        source:"https://github.com/moon-saha-chowdhury/crispy-snacks-client",
    },
    {
        projectName : "Top Soccer League 2020 Web App",
        description : "Through this app people can select their desire league and able to see the league details such as sport type, and so on.",
        technology:"React.js, Bootstrap, Netlify used for deployment.",
        workPhoto : soccer,
        link:" https://laughing-benz-99e9dc.netlify.app/",
        source: "https://github.com/moon-saha-chowdhury/top-soccer-leagues",
    }
];

const MyWork = () => {
    return (
        <div>
            <section className="my-5 pt-5">
                <div className="container">
                    <div className="section-header text-center">
                        <h3 className="text-warning pt-3">Some Of My Projects</h3>
                    </div>
                           <div>
                           {
                                workDetails.map(work =>
                                    <Fade bottom>
                                        <div style={{maxWidth:'840px'}} className="card my-5 mx-auto border border-4 border-warning rounded ">
                                        <MyWorkDetail work={work}>
                                        </MyWorkDetail></div>
                                    </Fade> )
                            }
                           </div>

                    </div>
            </section>
            
        </div>
    );
};

export default MyWork;